import type { Component } from 'vue';
import { Permission } from '@/types';
import { LocationQueryRaw } from 'vue-router';

export interface NavigationItem {
    localeKey: string;
    icon?: Component;
    to?: string;
    name?: string;
    tooltip?: string;
    permission?: Permission;
    children?: NavigationItem[];
    query?: LocationQueryRaw;
    isOpen?: boolean;
    activateBy?: string[];
}
